import { styled } from '@mui/system'

export const LeftBanner = styled('div')(({ theme }) => ({
  position: 'relative',
  left: 0,
  bottom: 0,
  cursor: 'pointer',
  width: 'calc(100vh/7)',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  '& a': {
    '& img': {
      height: '100%',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  },
}))

export const RightBanner = styled('div')(({ theme }) => ({
  position: 'relative',
  right: 0,
  bottom: 0,
  cursor: 'pointer',
  width: 'calc(100vh/7)',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  '& a': {
    '& img': {
      height: '100%',

      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  },
}))

export const MobileBannerCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: theme.spacing(2, 1),
  borderRadius: 12,
  paddingTop: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(1),
    margin: theme.spacing(0.5),
  },
  '& .mBanner': {
    width: '100%',
    borderRadius: 12,
  },
}))

export const SponsorTB = styled('div')(({ theme }) => ({
  position: 'relative',
  '& img': {
    width: '100%',
  },
  '& a': {
    '& img': {
      width: '100%',
    },
  },
}))
